// import downloadImages from './Image/Service/downloadImages';
import initForms from './services/Form/initForms';

export default async function initApp() {
  // check les dossiers en cours d'upload
  const formInit = initForms();

  // // check les images en cours de download ou upload
  const imageInit = ''; // initializeCheck().then(() => downloadImages()); //a remplacer

  return Promise.all([formInit, imageInit]);
}
